"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const isString_1 = __importDefault(require("lodash/isString"));
const Tabs_1 = __importDefault(require("../Internals/Tabs"));
const PageArea_1 = __importDefault(require("../PageArea/PageArea"));
const PageContent_1 = __importDefault(require("../PageContent/PageContent"));
const isChildFunction_1 = require("../utils/isChildFunction");
const Progress_1 = require("../Progress/Progress");
const Title_1 = require("../Typography/Title");
const styled_1 = __importDefault(require("../utils/styled"));
const Container = styled_1.default("div")(({ theme, hasTitle, hasTabs }) => ({
    position: "relative",
    height: "100%",
    display: "grid",
    gridRowGap: theme.space.element,
    backgroundColor: theme.color.white,
    gridTemplateRows: `${hasTitle ? `min-content ` : ""}${hasTabs ? `${theme.tabsBarHeight}px ` : ""}auto`,
    padding: "50px 35px 35px",
    overflow: "auto",
}));
const TitleContainer = styled_1.default("div", { shouldForwardProp: prop => prop !== "fill" })(({ theme, fill }) => ({
    display: "flex",
    alignItems: "center",
    fontWeight: theme.font.weight.medium,
    minWidth: theme.pageSize.min,
    maxWidth: fill ? "100%" : `${theme.pageSize.max}px`,
}));
const ViewContainer = styled_1.default("div", { shouldForwardProp: prop => prop !== "fill" }) `
  outline: none;
  min-width: ${({ theme }) => theme.pageSize.min}px;
  max-width: ${({ fill, theme }) => (fill ? "100%" : `${theme.pageSize.max}px`)};
  overflow-y: auto;
  overflow-x: hidden;
`;
const ActionsContainer = styled_1.default("div") `
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
`;
const TabsContainer = styled_1.default("div", { shouldForwardProp: prop => prop !== "fill" }) `
  min-width: ${({ theme }) => theme.pageSize.min}px;
  max-width: ${({ theme, fill }) => (fill ? "100%" : `${theme.pageSize.max}px`)};
`;
const Page = (_a) => {
    var { actions, activeTabName, areas = "main", children, fill, loading, noPadding, onTabChange, tabs, title } = _a, props = __rest(_a, ["actions", "activeTabName", "areas", "children", "fill", "loading", "noPadding", "onTabChange", "tabs", "title"]);
    const page = tabs ? (React.createElement(Tabs_1.default, { tabs: tabs, activeTabName: activeTabName, onTabChange: onTabChange }, ({ tabsBar, activeChildren, activeTabId }) => (React.createElement(React.Fragment, null,
        title ? (React.createElement(React.Fragment, null,
            React.createElement(TitleContainer, { fill: Boolean(fill) },
                isString_1.default(title) ? React.createElement(Title_1.Title, null, title) : title,
                React.createElement(ActionsContainer, null, actions)),
            React.createElement(TabsContainer, { fill: Boolean(fill) }, tabsBar))) : (React.createElement(TabsContainer, { fill: Boolean(fill) }, tabsBar)),
        React.createElement(ViewContainer, { fill: Boolean(fill), "aria-labelledby": activeTabId, role: "tabpanel", tabIndex: 0 }, activeChildren))))) : (React.createElement(React.Fragment, null,
        title && (React.createElement(TitleContainer, { fill: Boolean(fill) },
            isString_1.default(title) ? React.createElement(Title_1.Title, null, title) : title,
            React.createElement(ActionsContainer, null, actions))),
        React.createElement(ViewContainer, { fill: Boolean(fill) },
            React.createElement(PageContent_1.default, { noPadding: Boolean(noPadding), areas: areas, fill: fill }, modalConfirmContext => {
                const resolvedChildren = isChildFunction_1.isChildFunction(children) ? children(modalConfirmContext) : children;
                return areas === "main" ? React.createElement(PageArea_1.default, { fill: fill }, resolvedChildren) : resolvedChildren;
            }))));
    return (React.createElement(Container, Object.assign({ hasTabs: Boolean(tabs), hasTitle: Boolean(title) }, props),
        loading && React.createElement(Progress_1.FixedProgress, null),
        page));
};
exports.default = Page;
//# sourceMappingURL=Page.js.map